import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {Box, useSlotRecipe} from '@chakra-ui/react3'
import ModuleContainer from '../../components/cms/module-container'
import CTA from '../../components/cms/cta'
import RichText from '../../components/cms/rich-text'
import textBannerSlotRecipe from './index.recipe'

const TextBanner = React.forwardRef(
    (
        {
            moduleId,
            moduleType,
            pageId,
            anchor,
            copy,
            cta,
            colorWorld,
            color,
            backgroundColor,
            spacing
        },
        ref
    ) => {
        const recipe = useSlotRecipe({recipe: textBannerSlotRecipe})
        const styles = useMemo(() => recipe({colorWorld}), [recipe, colorWorld])

        // Custom color overrides from Momentvm color picker (hex strings)
        // take precedence over colorWorld recipe variants
        const customColorOverrides = useMemo(() => {
            const overrides = {}
            if (color) overrides.color = color
            if (backgroundColor) overrides.backgroundColor = backgroundColor
            return overrides
        }, [color, backgroundColor])

        return (
            <ModuleContainer
                moduleId={moduleId}
                moduleType={moduleType}
                pageId={pageId}
                anchor={anchor}
                spacing={spacing}
                ref={ref}
            >
                <Box css={[styles.root, customColorOverrides]}>
                    <Box css={styles.contentContainer}>
                        {copy?.text && (
                            <Box css={styles.copyWrapper}>
                                <RichText>{copy.text}</RichText>
                            </Box>
                        )}
                        {cta?.label && (
                            <Box css={styles.ctaWrapper}>
                                <CTA
                                    {...cta}
                                    css={color ? {color} : undefined}
                                    trackingContext={{
                                        moduleName: moduleType,
                                        eventLabel: 'cta'
                                    }}
                                />
                            </Box>
                        )}
                    </Box>
                </Box>
            </ModuleContainer>
        )
    }
)

if (process.env.NODE_ENV !== 'production') {
    TextBanner.displayName = 'TextBanner'
}

TextBanner.propTypes = {
    anchor: PropTypes.string,
    copy: PropTypes.shape({
        text: PropTypes.string
    }),
    cta: PropTypes.object,
    colorWorld: PropTypes.oneOf(Object.keys(textBannerSlotRecipe.variants.colorWorld)),
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
    spacing: PropTypes.oneOf(['default', 'reduced', 'min', 'min-top', 'min-bottom', 'none']),
    moduleId: PropTypes.string,
    moduleType: PropTypes.string,
    pageId: PropTypes.string
}

export default TextBanner
